var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeMachinePoi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    fill: "#0000FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9937 21.75H30.0012C30.399 21.75 30.7805 21.908 31.0618 22.1893C31.3432 22.4706 31.5012 22.8522 31.5012 23.25V27.75C31.5014 28.9324 31.2687 30.1033 30.8163 31.1958C30.364 32.2882 29.7008 33.2809 28.8648 34.1171C28.0288 34.9532 27.0362 35.6165 25.9438 36.069C24.8514 36.5216 23.6806 36.7545 22.4982 36.7545H19.4967C18.3143 36.7547 17.1434 36.522 16.0509 36.0696C14.9585 35.6173 13.9658 34.9541 13.1296 34.1181C12.2935 33.2821 11.6302 32.2895 11.1776 31.1971C10.7251 30.1048 10.4922 28.9339 10.4922 27.7515V23.25C10.4922 22.8522 10.6502 22.4706 10.9315 22.1893C11.2128 21.908 11.5944 21.75 11.9922 21.75H11.9937Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2493 17.2471C25.2502 16.1971 25.2502 14.5471 26.2493 13.4971C27.2512 12.4456 27.2512 10.7941 26.2493 9.74414",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0015 17.2471C19.9995 16.1971 19.9995 14.5471 21.0015 13.4971C22.0005 12.4456 22.0005 10.7941 21.0015 9.74414",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7504 17.2471C14.7499 16.1971 14.7499 14.5471 15.7504 13.4971C16.7509 12.4456 16.7509 10.7941 15.7504 9.74414",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.192 32.426L32.961 31.793C34.2517 31.4978 35.404 30.7731 36.2291 29.7376C37.0542 28.702 37.5034 27.4171 37.503 26.093C37.503 25.5224 37.3906 24.9574 37.1722 24.4303C36.9538 23.9032 36.6337 23.4242 36.2301 23.0208C35.8266 22.6174 35.3476 22.2975 34.8203 22.0793C34.2931 21.861 33.7281 21.7488 33.1575 21.749H29.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMachinePoi);
export default __webpack_public_path__ + "static/media/coffee-machine-poi.533c52862643bbbe4c1da778c2450ab0.svg";
export { ForwardRef as ReactComponent };